import CityPageTemplate from "../city-template/CityPageTemplate";
import { brookingsConfig } from "./data";

export default function BrookingsPage() {
  return <CityPageTemplate config={brookingsConfig} />;
}